import { useAppSelector } from "core/utils";
import type { FC } from "react";

import { getNotificationData } from "../../core/setup/redux/state/notifications/selectors";
import type { NoneOwnProps } from "../../core/types";
import { NotificationAlert } from "./NotificationAlert";

export const NotificationAlertManager: FC<NoneOwnProps> = () => {
    const { show, title, titleKey, text, type, data } = useAppSelector(getNotificationData);

    if (show && type && (title || text)) {
        // The text is already pre-formatted by the error handler middleware
        // Just display it as-is
        return (
            <NotificationAlert type={type} description={text || `this is a ${type} alert`} titleKey={titleKey} show={show} data={data} />
        );
    }
    return null;
};
